import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, GlobeIcon, UsersIcon, LockIcon, ChevronRightIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function Caption() {
  const navigate = useNavigate();
  const [caption, setCaption] = useState('');
  const [audience, setAudience] = useState('Public');
  const SUGGESTED_HASHTAGS = ['#comedy', '#fyp', '#funny', '#standup'];
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-678">
      {/* Header */}
      <div className="px-4 py-4 flex items-center border-b border-border" data-id="element-679">
        <button onClick={() => navigate(-1)} className="text-white mr-4" data-id="element-680">
          <ArrowLeftIcon size={24} data-id="element-681" />
        </button>
        <h1 className="text-white font-poppins font-bold text-lg" data-id="element-682">Post</h1>
      </div>

      <div className="flex-1 overflow-y-auto no-scrollbar pb-6" data-id="element-683">
        {/* Input Area */}
        <div className="p-4 flex gap-4 border-b border-border" data-id="element-684">
          <textarea value={caption} onChange={e => setCaption(e.target.value)} placeholder="Describe your video... Add hashtags or @mentions" className="flex-1 bg-transparent text-white placeholder:text-softGray resize-none focus:outline-none min-h-[100px] text-sm" data-id="element-685" />
          <div className="w-20 h-28 bg-gradient-to-br from-slate-800 to-slate-900 rounded-lg border border-border shrink-0" data-id="element-686" />
        </div>

        {/* Hashtag Suggestions */}
        <div className="px-4 py-3 border-b border-border flex gap-2 overflow-x-auto no-scrollbar" data-id="element-687">
          {SUGGESTED_HASHTAGS.map(tag => <button key={tag} onClick={() => setCaption(prev => prev + ' ' + tag)} className="bg-surface border border-border px-3 py-1.5 rounded-full text-white text-xs whitespace-nowrap" data-id="element-688">
              {tag}
            </button>)}
        </div>

        {/* Settings */}
        <div className="px-4 py-2" data-id="element-689">
          <button className="w-full py-4 flex items-center justify-between border-b border-border group" data-id="element-690">
            <div className="flex items-center gap-3 text-white" data-id="element-691">
              <GlobeIcon size={20} className="text-softGray" data-id="element-692" />
              <span className="text-sm font-medium" data-id="element-693">
                Who can watch this video
              </span>
            </div>
            <div className="flex items-center gap-2 text-softGray" data-id="element-694">
              <span className="text-sm" data-id="element-695">{audience}</span>
              <ChevronRightIcon size={16} data-id="element-696" />
            </div>
          </button>

          <div className="py-4 flex items-center justify-between border-b border-border" data-id="element-697">
            <span className="text-white text-sm font-medium" data-id="element-698">
              Allow comments
            </span>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-699">
              <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-700" />
              <div className="w-11 h-6 bg-surface peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-701"></div>
            </label>
          </div>

          <div className="py-4 flex items-center justify-between border-b border-border" data-id="element-702">
            <span className="text-white text-sm font-medium" data-id="element-703">Allow duets</span>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-704">
              <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-705" />
              <div className="w-11 h-6 bg-surface peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-706"></div>
            </label>
          </div>
        </div>
      </div>

      {/* Bottom Actions */}
      <div className="p-4 flex gap-3 bg-black border-t border-border" data-id="element-707">
        <Button variant="secondary" className="flex-1" onClick={() => navigate('/feed')} data-id="element-708">
          Drafts
        </Button>
        <Button className="flex-1" onClick={() => navigate('/upload/progress')} data-id="element-709">
          Post
        </Button>
      </div>
    </div>;
}